/* eslint-disable max-len */
import React from 'react';

export function Discord(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" fill="none" viewBox="0 0 16 12" {...props}>
      <path
        fill="url(#paint0_linear_2272_43212)"
        d="M13.553 1.005A13.335 13.335 0 0010.253 0a9.25 9.25 0 00-.423.85C8.599.672 7.38.672 6.17.85A8.973 8.973 0 005.744 0 13.291 13.291 0 002.44 1.007C.351 4.066-.215 7.05.068 9.99a13.36 13.36 0 004.048 2.01c.326-.435.617-.897.867-1.384a8.648 8.648 0 01-1.365-.644c.115-.082.227-.168.335-.256 2.632 1.193 5.493 1.193 8.094 0 .11.088.222.174.335.256-.433.253-.891.47-1.368.646.25.485.54.948.867 1.383a13.336 13.336 0 004.051-2.011c.332-3.409-.568-6.364-2.379-8.984zm-8.21 7.176c-.791 0-1.44-.715-1.44-1.586 0-.87.635-1.586 1.44-1.586.803 0 1.451.715 1.438 1.586 0 .87-.635 1.586-1.439 1.586zm5.315 0c-.79 0-1.439-.715-1.439-1.586 0-.87.635-1.586 1.439-1.586s1.452.715 1.438 1.586c0 .87-.634 1.586-1.438 1.586z"
      ></path>
      <defs>
        <linearGradient id="paint0_linear_2272_43212" x1="0" x2="16" y1="6" y2="6" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DD2476"></stop>
          <stop offset="1" stopColor="#FF512F"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
